export default "__VITE_ASSET__BsQm72ZJ__"